/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { Helmet } from 'react-helmet-async';

import { Provider as CdsProvider, Typography, Typography2 } from '@coursera/cds-core';

import ChatLoader from 'bundles/common/components/ChatLoader';
import useBoostChatConfig from 'bundles/composable-page-header/hooks/useBoostChatConfig';
import NotFound from 'bundles/phoenix/components/NotFound';
import inServerContext from 'bundles/ssr/util/inServerContext';

/**
 * This is a temporary page for testing chat and chatbots.
 * It can't be seen by real users because it's not linked from anywhere and we do an EPIC check.
 */
const ChatPage = () => {
  const { enableChat, boostInstanceName, configValues, loading } = useBoostChatConfig();
  if (inServerContext || loading) {
    return null; // prevent flash of <NotFound /> component in case of client-side EPIC loading (e.g. via overrides)
  }

  if (!enableChat) {
    return <NotFound />;
  }

  return (
    <CdsProvider locale="en">
      <Helmet title="Chat With Us" />
      <main>
        <section css={{ display: 'grid', justifyItems: 'center' }}>
          <Typography variant="h1" color="body">
            Chat With Us
          </Typography>

          {/* Copy below was taken from https://www.coursera.support/s/lhc-chat-support and was placed here just in case this page somehow comes up for someone */}
          <Typography2 component="p" variant="bodyPrimary" css={{ marginTop: '1rem' }}>
            You’re seeing this page because we’re currently improving our chat experience.
          </Typography2>
          <Typography2 component="p" variant="bodyPrimary" css={{ marginTop: '1rem' }}>
            To chat with us please click or tap the icon near the bottom-right corner of this page.
          </Typography2>
          <Typography2 component="p" variant="bodyPrimary" css={{ marginTop: '1rem' }}>
            Thank you for contacting Coursera support!
          </Typography2>
        </section>
      </main>
      <ChatLoader boostInstanceName={boostInstanceName} configValues={configValues} skipTargetingCheck />
    </CdsProvider>
  );
};

export default ChatPage;
